import React, { useState, useEffect, useCallback } from 'react';
import Pagination from '@mui/material/Pagination';
import moment from 'moment';
import Notification from '../../components/Notification';
import CreateFence from '../../components/CreateFence';
import useApi from '../../api/useApi';

function GeoFence() {
  let user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }

  const orgId = user && JSON.parse(sessionStorage.user).organization.id;
  user = user && JSON.parse(sessionStorage.user).user.userName;

  const [geofence, setGeofence] = useState([]);
  const [selectedFence, setSelectedFence] = useState({ id: '', name: '', action: 'create' });
  const [onClose, setOnClose] = useState(false);
  const [showfence, setShowFence] = useState(false);
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [{ isLoading, isError, data }, getData] = useApi();
  const [fence, removeFence] = useApi();
  const [formData, setFormData] = useState({ q: '', status: '', scope: '' });
  const [searchApi, searchApiData] = useApi();

  const [pageCount, setpageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchFlag, setSearchFlag] = useState(false);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const day = 1000 * 60 * 60 * 24;
  let itemsPerPage;

  if (window.screen.height <= 768) itemsPerPage = 10;
  else if (window.screen.height > 768 && window.screen.height <= 980) itemsPerPage = 12;
  else if (window.screen.height > 980 && window.screen.height <= 1080) itemsPerPage = 15;
  else if (window.screen.height > 1080 && window.screen.height <= 1440) itemsPerPage = 18;
  else if (window.screen.height > 1440 && window.screen.height <= 1800) itemsPerPage = 21;
  else if (window.screen.height > 1800 && window.screen.height <= 2160) itemsPerPage = 24;
  else if (window.screen.height > 2160) itemsPerPage = 27;

  // useEffect(() => {
  //   getData(`/organization/${orgId}/geofences?limit=${itemsPerPage}&page=${page}`, 'GET');
  // }, []);

  useEffect(() => {
    getData(`/organization/${orgId}/geofences?limit=${itemsPerPage}&page=${page}`, 'GET');
  }, [page]);

  useEffect(() => {
    user && getData(`/organization/${orgId}/geofences?level=${formData.scope}&limit=${itemsPerPage}&page=1`, 'GET');
    setPage(1);
  }, [formData.scope]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setGeofence(data.geofences);

      if (page === 1) {
        const total = Math.ceil(data.count / itemsPerPage);
        setpageCount(total);
      }
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (!searchApi.isLoading && !searchApi.isError && searchApi.data) {
      setGeofence(searchApi.data.geofences);
    }
  }, [searchApi.isLoading, searchApi.isError, searchApi.data]);

  const toggleFence = () => {
    setShowFence((prev) => !prev);
  };

  const handleDelete = () => {
    removeFence(`/geofence/${selectedFence.id}`, 'DELETE');
  };

  useEffect(() => {
    if (fence.data) {
      getData(`/organization/${orgId}/geofences?limit=${itemsPerPage}&page=${page}`, 'GET');
      setType('delete');
      setOnClose(false);
      setMessage('GeoFence deleted successfully');
      setNotification(!notification);
    }
  }, [fence]);

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  const alertMsg = (msg) => {
    setNotification(msg);
  };

  const refreshList = () => {
    getData(`/organization/${orgId}/geofences?limit=${itemsPerPage}&page=${page}`, 'GET');
    // toggleOpenCreate();
  };

  const searchData = () => {
    // setSearchFlag(true);
    searchApiData(`/organization/${orgId}/search?type=geofence&searchItem=${formData.q}`, 'GET');
  };

  // useEffect(() => {
  //   // if (filteredData.length <= 0) {
  //   //   return;
  //   // }
  //   // let z = filteredData;
  //   // if (formData.status === '') {
  //   //   setWebhook(filteredData);
  //   // }

  //   // if (formData.status) {
  //   //   z = z.filter((x) => x?.isActive.toString() === formData.status);
  //   // }

  //   // if (formData.scope) {
  //   //   z = z.filter((x) => (x?.level || 'ORGANIZATION') === formData.scope);
  //   // }

  //   // if (z.length > 0) setWebhook(z);
  //   // else setWebhook([]);

  //   getData(`/organization/${orgId}/geofences?isActive=false`, 'GET');
  // }, [formData.status, formData.scope]);

  return (
    <>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      {onClose && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-50"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-3/12 px-2 text-sm block m-auto rounded-2xl relative mobile_toggle">
            <span className="block p-4 font-bold border-b text-textBlue1">Delete GeoFence</span>
            <img
              src="assets/img/Close.svg"
              className="absolute top-3 right-3 h-3 cursor-pointer"
              alt=""
              onClick={() => setOnClose(false)}
            />
            <span className="block text-center text-sm mt-8 mb-8" style={{ color: '#9B9B9B' }}>
              Do you want to delete GeoFence {selectedFence.name}?
            </span>
            <div className="mb-6 font-bold flex items-center justify-center">
              {/* <div className="w-1/3" /> */}
              <div className="w-2/3 lg:flex sm:block">
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 lg:w-max w-auto border px-8 py-4 rounded-3xl text-xs font-semibold text-role mr-2 focus:outline-none flex justify-center items-center h-6"
                  onClick={() => {
                    setOnClose(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs font-semibold focus:outline-none flex justify-center items-center h-6 bg-btnBg text-white"
                  onClick={handleDelete}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showfence && (
        <CreateFence
          handleClose={toggleFence}
          action={selectedFence.action}
          geofenceId={selectedFence.id}
          notification={createNotification}
          refreshList={() => refreshList()}
        />
      )}
      <div className="mt-10 h-full bg-white mx-auto px-3 audit_ui overflow-auto">
        <div className="z-50" style={{ height: '21vh', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-titleColor font-bold text-base mobile_icon2">GeoFence</span>

            <div className="block lg:flex mt-1 lg:mt-0 ">
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setShowFence(true);
                  setSelectedFence({ action: 'create' });
                }}
              >
                Create New
                <img src="assets/img/Create.svg" className="h-2 ml-2 " alt="" />
              </button>
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs ml-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white mx-3 button_mobile41"
                onClick={() => {
                  // downloadExcel('tblData');
                }}
              >
                Report
                <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
              </button>
              <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl button_search21">
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none button_search2"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                  onKeyDown={(e) => {
                    if (e.which === 13) searchData();
                  }}
                />
                <img src="assets/img/Search.png" onClick={searchData} className="h-4 ml-2 button_search3" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="tbl mobile_view1" style={{ minWidth: '700px' }}>
          <div className="bg-white w-tableWidth m-auto mb-3">
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-1.5 flex w-full relative bg-primary text-white items-center">
                <div className=" py-2.5 text-xs font-bold w-3/12">NAMES</div>
                <div className=" py-2.5 text-xs font-bold w-1/12">RADIUS</div>
                <div className=" py-2.5 text-xs font-bold w-2/12">LONGITUDE</div>
                <div className=" py-2.5 text-xs font-bold w-2/12">LATITUDE</div>
                <div className="p-1 text-xs text-center font-semibold w-2/12">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.scope}
                      name="scope"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">SCOPE</option>
                      <option value="DEVICE">DEVICE</option>
                      {/* <option value="PROJECT">PROJECT</option> */}
                      <option value="ORGANIZATION">ORGANIZATION</option>
                    </select>
                  </div>
                </div>
                <div className=" py-2.5 text-xs font-bold w-2/12">STATUS</div>
                {/* <div className="text-xs font-bold w-2/12">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.scope}
                      name="scope"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-0 lg:pl-3 pr-5 lg:pr-6 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">SCOPE</option>
                      <option value="DEVICE">DEVICE</option>
                      <option value="PROJECT">PROJECT</option>
                      <option value="ORGANIZATION">ORGANIZATION</option>
                    </select>
                  </div>
                </div>
                <div className="text-xs font-bold w-2/12">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.status}
                      name="status"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-7 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">STATUS</option>
                      <option value="true">ACTIVE</option>
                      <option value="false">INACTIVE</option>
                    </select>
                  </div>
                </div> */}
                <div className=" py-2.5 text-xs font-bold w-1/12">ACTIONS</div>
              </div>
            </div>
            {isLoading ? (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            ) : (
              <div className="hideScroll" style={{ overflowY: 'scroll', height: '64vh' }}>
                <div id="tblData" className="w-full">
                  {geofence.map((item) => (
                    <div
                      className="my-2 px-8 py-1 xl:py-1.5 items-center flex
                relative hover:border-indigo-200 focus-within:border-indigo-200"
                      style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                    >
                      <div className="text-role font-semibold w-3/12 py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs">
                        {item?.name}
                      </div>
                      <div className="text-role font-semibold w-1/12 py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs">
                        {/* Added Alarm Rule Excursion */}
                        {item?.radius}
                      </div>
                      <div className="text-role font-semibold uppercase w-2/12 py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs">
                        {/* Added Alarm Rule Excursion */}
                        {item?.longitude}
                      </div>
                      <div className="text-role font-semibold w-2/12 py-2 pr-3 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs">
                        {item?.latitude}
                      </div>
                      <div className="text-role font-semibold w-2/12 py-2 pr-3 text-left overflow-ellipsis overflow-hidden whitespace-nowrap pl-4 text-xs">
                        {/* Name Excursion */}
                        {item?.level}
                      </div>
                      <div
                        className={`text-${
                          item?.isActive ? 'green-600' : 'red-600'
                        } text-left py-2 pl-4 font-semibold overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12`}
                      >
                        {item?.isActive ? 'Active' : 'Inactive'}
                      </div>
                      <div className="flex text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/12">
                        <img
                          src="assets/img/Edit2.svg"
                          className="h-3 mr-4 "
                          alt=""
                          onClick={() => {
                            setSelectedFence({ id: item?.id, action: 'update' });
                            toggleFence();
                            // toggleOpenCreate();
                          }}
                        />
                        <img
                          src="assets/img/Delete2.svg"
                          className="h-3"
                          alt=""
                          onClick={() => {
                            setSelectedFence({ id: item?.id, name: item?.name });
                            setOnClose(true);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {!searchFlag && (
              <div className="block lg:flex mt-1 lg:mt-0">
                <Pagination
                  className="mt-4 ml-auto shadow-2xl"
                  count={pageCount}
                  page={page}
                  onChange={handleChange}
                  variant="outlined"
                  shape="rounded"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default GeoFence;
